import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { fontWeight, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const highlightedSectionHeader = style([
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: space.s16,
  },
]);

export const highlightedSection = style({
  padding: space.s24,
  backgroundColor: themeVars.container.secondary.background.idle,
  display: 'flex',
  flexDirection: 'column',
  gap: space.s24,

  selectors: {
    '&[data-empty]': {
      backgroundColor: themeVars.container.primary.background.idle,
    },
  },
});

export const sectionLabel = style([
  {
    fontWeight: fontWeight.medium,
    flexShrink: 0,
  },
  responsiveStyle({
    mobile: {
      ...typography.labelLg,
    },
    tablet: {},
    laptop: {
      ...typography.titleLg,
    },
  }),
]);

export const listContainer = style([
  {
    boxShadow: 'none',
    outline: 'none',
  },
]);
